import React from 'react';
import Style from './BaseLayout.module.scss';
import Navbar from './Navbar';
import Home from './home/Home';
import About from './about/About';
import Experience from './experience/Experience';
import PostList from './writing/PostList';
import PostPage from './writing/PostPage';
import Planner from './planner/Planner';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import { info } from '../assets/info/Info';
import { publishedTechnical, publishedThoughts } from '../assets/info/Posts';

export default function BaseLayout() {
  return (
    <Box className={Style.light}>
      <Navbar />
      <Routes>
        <Route exact path={'/'} element={<Home />} />
        <Route exact path={'/about'} element={<About />} />
        <Route exact path={'/experience'} element={<Experience />} />
        <Route exact path={'/planner'} element={<Planner />} />

        <Route
          exact
          path={'/technical'}
          element={
            <PostList
              posts={publishedTechnical}
              basePath={'/technical'}
              empty={'No write-ups yet — check back soon.'}
            />
          }
        />
        <Route
          exact
          path={'/technical/:slug'}
          element={
            <PostPage
              posts={publishedTechnical}
              basePath={'/technical'}
              backLabel={'All write-ups'}
            />
          }
        />

        <Route
          exact
          path={'/thoughts'}
          element={
            <PostList
              posts={publishedThoughts}
              basePath={'/thoughts'}
              empty={'Nothing here yet — check back soon.'}
            />
          }
        />
        <Route
          exact
          path={'/thoughts/:slug'}
          element={
            <PostPage posts={publishedThoughts} basePath={'/thoughts'} backLabel={'All thoughts'} />
          }
        />
      </Routes>
      <Box component={'footer'} className={Style.footer}>
        <p>Last updated: {info.lastUpdated}</p>
      </Box>
    </Box>
  );
}
